<template>
  <div>
    <v-btn
      v-if="chat.id"
      x-small
      :href="`${$appEndPoint}/chats/${chat.id}`"
      target="_blank"
      outlined
      color="secondary"
    >
      Coach Chat
    </v-btn>

    <v-btn v-else-if="userId && coachId" x-small color="primary" @click="createCoachingChat" :loading="loading">
      Create Coach Chat
    </v-btn>
  </div>
</template>

<script>
import { CREATE_CLUB_COACH_CHAT_MUTATION } from "@/graphql/mutations/chat";

export default {
  name: "CoachingChatButton",
  props: {
    coachingChatId: {
      type: [Number, String],
      required: false,
    },
    userId: {
      type: [Number, String],
      required: false,
    },
    coachId: {
      type: [Number, String],
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      chat: {
        id: this.coachingChatId,
        creatorId: this.coachId,
        userId: this.userId,
      },
    };
  },
  methods: {
    async createCoachingChat() {
      this.loading = true;
      const result = await this.$apollo.mutate({
        mutation: CREATE_CLUB_COACH_CHAT_MUTATION,
        variables: {
          userId: this.userId,
          coachId: this.coachId,
        },
      });
      this.chat.id = result.data?.createCoachingChatMutation?.id;
      this.loading = false;
    },
  },
};
</script>
